module.exports = __webpack_public_path__ + "media/svg/thin-chevron-c30a06d8.svg";